import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
  dummy: string;
}

const initialState: IState = {
  dummy: '',
};

const hubSlice = createSlice({
  name: 'hub',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
  },
});

export const actions = hubSlice.actions;
export default hubSlice.reducer;
